import { lazy } from 'react';
import { IconCommon, IconDice, IconUser, IconCommand, IconFilePdf, IconUserGroup, IconStorage, IconDesktop, IconIdcard } from '@arco-design/web-react/icon';

export const LOGIN = "/login"

export const DEVICE_LIST = '/device/list'
export const DEVICE_ADD = '/device/add'
export const DEVICE_UPDATE = '/device/update'
export const DEVICE_DETAIL = '/device/detail'

export const BILLING_TEMPLATE_LIST = '/billingtemplate/list'
export const BILLING_TEMPLATE_ADD = '/billingtemplate/add'
export const BILLING_TEMPLATE_UPDATE = '/billingtemplate/update'
export const BILLING_TEMPLATE_DETAIL = '/billingtemplate/detail/:id'

export const ORDER_LIST = '/order/list'
export const ORDER_REPORTS = '/order/reports'

export const PUSH_MESSAGE_LIST = '/pushmessage/list'

export const MANAGER_LIST = '/manager/list'
export const MANAGER_ADD = '/manager/add'
export const MANAGER_CHNAGE_PASSWORD = '/manager/changepassword'

export const USER_LIST = '/user/list'

export const REPORTING_LIST = '/reporting/list'
export const REPORTING_CURRENT = '/reporting/current'

export const DOOR_OPEN_LOG = '/doorOpenLog/list'

export const MERCHANT_LIST = "/merchant/list"
export const MERCHANT_ADD = "/merchant/add"
export const MERCHANT_DETAIL = "/merchant/detail"
export const MERCHANT_UPDATE = "/merchant/:merchantId/update"
export const MERCHANT_ROYALTY_ACCOUNT_UPDATE = "/merchant/:merchantId/royaltyAccountUpdate"

export const SALESPERSON_LIST = "/salesperson/list"
export const SALESPERSON_ADD = "/salesperson/add"
export const SALESPERSON_DETAIL = "/salesperson/detail"
export const SALESPERSON_UPDATE = "/salesperson/:salespersonId/update"
export const SALESPERSON_ACCOUNT_UPDATE = "/salesperson/:salespersonId/accountUpdate"

export const MERCHANT_LOGIN_ACCOUNT_LIST = "/merchant/account/list"
export const MERCHANT_LOGIN_ACCOUNT_ADD = "/merchant/account/add"
export const MERCHANT_LOGIN_ACCOUNT_UPDATE = "/merchant/account/:accountId/update"

export const ROYALTY_RECEIVING_ACCOUNT_BAND_WX = "/royaltyReceivingAccount/bandWx"

export const AUTH_FUND_ORDER_LIST = "/authfundorder/list"

export const HOME_PAGE = DEVICE_LIST

export const routeList = [

    {
        name: '设备管理',
        icon: IconCommon,
        children: [
            {
                key: DEVICE_LIST,
                path: DEVICE_LIST,
                name: '设备列表',
                show: true,
                component: lazy(() => import('./pages/device/list')),// 路由懒加载 Js可拆分
            },
            {
                key: DEVICE_ADD,
                path: DEVICE_ADD,
                name: '添加设备',
                show: true,
                component: lazy(() => import('./pages/device/add')),
            },
            {
                key: DEVICE_UPDATE,
                path: DEVICE_UPDATE + "/:id",
                name: '更新设备',
                show: false,
                component: lazy(() => import('./pages/device/update')),
            },
            {
                key: DEVICE_DETAIL,
                path: DEVICE_DETAIL + "/:id",
                name: '设备详情',
                show: false,
                component: lazy(() => import('./pages/device/detail')),
            }
        ]
    },
    {
        name: '商家管理',
        icon: IconDesktop,
        children: [
            {
                key: MERCHANT_LIST,
                path: MERCHANT_LIST,
                name: '商家列表',
                show: true,
                component: lazy(() => import('./pages/merchant/list')),
            },
            {
                key: MERCHANT_ADD,
                path: MERCHANT_ADD,
                name: '添加商家',
                show: true,
                component: lazy(() => import('./pages/merchant/add')),
            },
            {
                key: MERCHANT_LOGIN_ACCOUNT_LIST,
                path: MERCHANT_LOGIN_ACCOUNT_LIST,
                name: '商家登录账号',
                show: true,
                component: lazy(() => import('./pages/merchantAccount/list')),
            },
            {
                key: MERCHANT_LOGIN_ACCOUNT_ADD,
                path: MERCHANT_LOGIN_ACCOUNT_ADD,
                name: '添加商家登录账号',
                show: true,
                component: lazy(() => import('./pages/merchantAccount/add')),
            },
            {
                key: MERCHANT_DETAIL,
                path: MERCHANT_DETAIL + "/:merchantId",
                name: '商家详情',
                show: false,
                component: lazy(() => import('./pages/merchant/detail')),
            },
            {
                key: MERCHANT_ROYALTY_ACCOUNT_UPDATE,
                path: MERCHANT_ROYALTY_ACCOUNT_UPDATE,
                name: '修改商家收款账号',
                show: false,
                component: lazy(() => import('./pages/merchant/royaltyAccount/update')),
            },
            {
                key: MERCHANT_UPDATE,
                path: MERCHANT_UPDATE,
                name: '修改商家信息',
                show: false,
                component: lazy(() => import('./pages/merchant/update')),
            },
        ]
    },
    {
        name: '销售员管理',
        icon: IconIdcard,
        children: [
            {
                key: SALESPERSON_LIST,
                path: SALESPERSON_LIST,
                name: '销售员列表',
                show: true,
                component: lazy(() => import('./pages/salesperson/list')),
            },
            {
                key: SALESPERSON_ADD,
                path: SALESPERSON_ADD,
                name: '添加销售员',
                show: true,
                component: lazy(() => import('./pages/salesperson/add')),
            },
            {
                key: SALESPERSON_DETAIL,
                path: SALESPERSON_DETAIL + "/:salespersonId",
                name: '销售员详情',
                show: false,
                component: lazy(() => import('./pages/salesperson/detail')),
            },
            {
                key: SALESPERSON_ACCOUNT_UPDATE,
                path: SALESPERSON_ACCOUNT_UPDATE,
                name: '修改销售员收款账号',
                show: false,
                component: lazy(() => import('./pages/salesperson/account/update')),
            },
            {
                key: SALESPERSON_UPDATE,
                path: SALESPERSON_UPDATE,
                name: '修改销售员信息',
                show: false,
                component: lazy(() => import('./pages/salesperson/update')),
            },
        ]
    },
    {
        name: '计费模板',
        icon: IconDice,
        children: [
            {
                key: BILLING_TEMPLATE_LIST,
                path: BILLING_TEMPLATE_LIST,
                name: '计费模板列表',
                show: true,
                component: lazy(() => import('./pages/billingtemplate/list')),
            },
            {
                key: BILLING_TEMPLATE_ADD,
                path: BILLING_TEMPLATE_ADD,
                name: '添加计费模板',
                show: true,
                component: lazy(() => import('./pages/billingtemplate/add')),
            },
            {
                key: BILLING_TEMPLATE_UPDATE,
                path: BILLING_TEMPLATE_UPDATE + "/:id",
                name: '编辑计费模板',
                show: false,
                component: lazy(() => import('./pages/billingtemplate/update')),
            },
            {
                key: BILLING_TEMPLATE_DETAIL,
                path: BILLING_TEMPLATE_DETAIL,
                name: '计费模板详情',
                show: false,
                component: lazy(() => import('./pages/billingtemplate/detail')),
            }
        ]
    },
    {
        name: '订单管理',
        icon: IconCommand,
        children: [
            {
                key: ORDER_LIST,
                path: ORDER_LIST,
                name: '订单列表',
                show: true,
                component: lazy(() => import('./pages/order/list')),
            },
            {
                key: ORDER_REPORTS,
                path: ORDER_REPORTS,
                name: '订单报表',
                show: true,
                component: lazy(() => import('./pages/order/reports')),
            },
            {
                key: DOOR_OPEN_LOG,
                path: DOOR_OPEN_LOG,
                name: '开门日志',
                show: true,
                component: lazy(() => import('./pages/door/openLog')),
            },
            {
                key: AUTH_FUND_ORDER_LIST,
                path: AUTH_FUND_ORDER_LIST,
                name: '押金列表',
                show: true,
                component: lazy(() => import('./pages/authfundorder/list')),
            },
        ]
    },
    {
        name: '用户管理',
        icon: IconUser,
        children: [
            {
                key: USER_LIST,
                path: USER_LIST,
                name: '用户列表',
                show: true,
                component: lazy(() => import('./pages/user/list')),
            },
        ]
    },
    {
        name: '推送消息',
        icon: IconFilePdf,
        children: [
            {
                key: PUSH_MESSAGE_LIST,
                path: PUSH_MESSAGE_LIST,
                name: '消息列表',
                show: true,
                component: lazy(() => import('./pages/message/list')),
            },
        ]
    },
    {
        name: '管理员',
        icon: IconUserGroup,
        children: [
            {
                key: MANAGER_LIST,
                path: MANAGER_LIST,
                name: '管理员列表',
                show: true,
                component: lazy(() => import('./pages/manager/list')),
            },
            {
                key: MANAGER_ADD,
                path: MANAGER_ADD,
                name: '添加管理员',
                show: true,
                component: lazy(() => import('./pages/manager/add')),
            },
            {
                key: MANAGER_CHNAGE_PASSWORD,
                path: MANAGER_CHNAGE_PASSWORD,
                name: '修改密码',
                show: true,
                component: lazy(() => import('./pages/manager/changepassword')),
            }
        ]
    },
    {
        name: '结算',
        icon: IconStorage,
        children: [
            {
                key: REPORTING_LIST,
                path: REPORTING_LIST,
                name: '结算列表',
                show: true,
                component: lazy(() => import('./pages/reporting/list')),
            }, {
                key: REPORTING_CURRENT,
                path: REPORTING_CURRENT,
                name: '当月统计',
                show: true,
                component: lazy(() => import('./pages/reporting/current')),
            }
        ]
    }
]

